import Blue from '~/core'

new Blue({
  name: 'Accordion',
  selector: '.accordion',
  setup(accordion) {
    const items = [...accordion.querySelectorAll('[class*=__item]')]
    const relations = []

    items.forEach((container) => {
      let trigger = container.querySelector('[class*=__trigger]')
      let content = container.querySelector('[class*=__content]')
      let config = {
        container,
        trigger,
        content,
        relations,
        props: ['height', 'opacity', 'visibility'],
      }
      relations.push(new this.$toggle(config))
    })
  },
})
